import React from 'react'
import {
    Button,
    Div,
    FormItem,
    FormLayout,
    Input,
    List,
    SimpleCell,
    CellButton,
    Avatar,
    ButtonGroup
} from "@vkontakte/vkui";
import {Icon28AddOutline} from "@vkontakte/icons";
import IMask from "imask";
import axios from "axios";

class KlientCreatorByPhone extends React.Component {


    constructor() {
        super();
        this.state = {
            items: null,
            createMode: false,
            unmaskedValue: '',
            value: '',
            phoneValid: false,
            loading: false,
            phone_error: '',
            first_name_error: '',
            last_name_error: '',
            first_name: '',
            last_name: '',
            search_name: '',
            sur_name: ''

        }
    }

    componentDidMount() {
        const self = this
        let phoneInput = document.getElementById("phone_search_input");

        const phoneMask = new IMask(phoneInput, {
            mask: "+{7}(000)000-00-00",
        });

        function phoneInputHandler(e) {
            if (phoneMask.masked.isComplete) {
                self.setState({phoneValid: true})
            } else {
                self.setState({phoneValid: false})
            }
            self.setState({unmaskedPhone: phoneMask.unmaskedValue, value: e.target.value})
        }

        phoneInput.addEventListener('input', phoneInputHandler)
    }

    render() {
        if (this.state.createMode) {
            return (
                [<Div>
                    <FormLayout label="Добавить клиента">
                        <FormItem top="Номер телефона" status={this.state.phone_error ? 'error' : 'default'}
                                  bottom={this.state.phone_error}>
                            <Input tabIndex="0"
                                   id="phone_search_input"
                                   type="text"
                                   placeholder="999 99-99"
                                   value={this.state.value}
                                   status={this.state.phone_error ? 'error' : 'default'}
                            />
                        </FormItem>
                        <FormItem top="Имя" status={this.state.first_name_error ? 'error' : 'default'}
                                  bottom={this.state.first_name_error}>
                            <Input autoFocus tabIndex="1"
                                   type="text"
                                   placeholder="Иван"
                                   value={this.state.first_name}
                                   onChange={(e) => this.setState({first_name: e.target.value})}
                                   status={this.state.first_name_error ? 'error' : 'default'}
                            />
                        </FormItem>
                        <FormItem top="Фамилия" status={this.state.last_name_error ? 'error' : 'default'}
                                  bottom={this.state.last_name_error}>
                            <Input tabIndex="2"
                                   type="text"
                                   placeholder="Петров"
                                   value={this.state.last_name}
                                   onChange={(e) => this.setState({last_name: e.target.value})}
                                   status={this.state.last_name_error ? 'error' : 'default'}
                            />
                        </FormItem>
                        <FormItem top="Отчество">
                            <Input tabIndex="3"
                                   type="text"
                                   placeholder="Петрович"
                                   value={this.state.sur_name}
                                   onChange={(e) => this.setState({sur_name: e.target.value})}
                            />
                        </FormItem>
                    </FormLayout>
                    <ButtonGroup stretched>
                        <Button onClick={() => this.AddKlient()} loading={this.state.loading}
                                disabled={this.state.loading} stretched size="l">Добавить</Button>
                        <Button onClick={() => this.props.close()} stretched mode="outline" size="l">Отмена</Button>
                    </ButtonGroup>
                </Div>
                ]
            )
        } else {
            return (
                [<Div>
                    <FormLayout>
                        <FormItem top="Введите номер телефона для поиска клиента"
                                   >
                            <Input
                                id="phone_search_input"
                                type="text"
                                placeholder="999 99-99"

                                after={
                                    <Button loading={this.state.loading} disabled={this.state.loading}
                                            hoverMode="opacity" size="l" mode="outline"
                                            onClick={() => this.searchByPhone()}
                                            disabled={!this.state.phoneValid || this.state.search_name}>
                                        Найти
                                    </Button>
                                }
                            />
                        </FormItem>
                    </FormLayout>
                    <FormLayout
                        style={{display: this.state.items !== null || this.state.loading ? 'none' : 'inherit'}}>
                        <FormItem top="Или имя/ИНН для поиска клиента"
                                  bottom={this.state.search_name && this.state.unmaskedPhone ? "Сделайте поиск только по телефону или только названию" : ''}
                                  status={this.state.search_name && this.state.unmaskedPhone ? "error" : ''}>
                            <Input
                                autoFocus
                                type="text"
                                placeholder="ООО Ромашка" onChange={(e) => this.setState({search_name: e.target.value})}

                                after={
                                    <Button hoverMode="opacity" size="l" mode="outline"
                                            onClick={() => this.searchByName()}
                                            disabled={!this.state.search_name || this.state.unmaskedPhone}>
                                        Найти
                                    </Button>
                                }
                            />
                        </FormItem>
                    </FormLayout>
                </Div>,
                    <Div>
                        <List>
                            {this.state.items !== null && this.state.items.length > 0 ? this.state.items.map((item, index) => (

                                <SimpleCell multiline onClick={() => this.addKlientToList(item)}
                                            after={item.phone}>{item.last_name} {item.first_name} {item.sur_name}</SimpleCell>

                            )) : (this.state.items !== null && this.state.items.length == 0 ?
                                <Div>Контрагент не найден по телефону. Создайте контрагента</Div> : '')}
                            {this.props.current_user && this.props.current_user.meta.settings && this.props.current_user.meta.settings.create_klients_by_phone == '1' && this.state.items !== null && this.state.items.length == 0 ?
                                <CellButton centered onClick={() => this.setState({createMode: true})}
                                            before={<Avatar withBorder={false} size={48}>
                                                <Icon28AddOutline/>
                                            </Avatar>}>
                                    Создать
                                </CellButton> : (this.state.items !== null && this.state.items.length == 0 ? <Div>
                                    <hr/>
                                    У вас не достаточно прав для создания контрагентов</Div> : '')}
                        </List>
                    </Div>])
        }
    }

    searchByPhone = () => {

        const body = new FormData()

        let sAjaxSource = '/?app=partnersklients&act=getKlientsFrom1CByPhone'

        body.append('phone', this.state.unmaskedPhone);

        this.setState({loading: true})
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        ).then((response) => {
            this.setState({loading: false})
            console.log(response)
            if (Array.isArray(response.data)) {
                this.setState({items: response.data})
            } else {
                window.postMessage({
                    type: 'error',
                    text: 'Свяжитесь с техподдержкой scladro и сообщите ошибку: ' + response.data,
                    timeout: 10000
                })
                this.props.close()
            }
        }).catch((error) => {
            console.log(error)
            if (error.response) {
                window.postMessage({
                    type: 'error',
                    text: 'Свяжитесь с техподдержкой scladro и сообщите ошибку: ' + error.response.data,
                    timeout: 10000
                })
                this.props.close()
            } else {
                window.postMessage({
                    type: 'error',
                    text: 'Свяжитесь с техподдержкой scladro и сообщите ошибку: ' + error.message,
                    timeout: 10000
                })
                this.props.close()
            }
        });

    }

    AddKlient = () => {


        let error = 0
        if (this.state.unmaskedPhone === undefined || this.state.unmaskedPhone == '') {
            error++
            this.setState({phone_error: 'Не указан телефон'})
        } else {
            this.setState({phone_error: ''})
        }
        if (this.state.first_name === undefined || this.state.first_name == '') {
            error++
            this.setState({first_name_error: 'Не указано имя'})
        } else {
            this.setState({first_name_error: ''})
        }
        if (this.state.last_name === undefined || this.state.last_name == '') {
            error++
            this.setState({last_name_error: 'Не указана фамилия'})
        } else {
            this.setState({last_name_error: ''})
        }
        if (error > 0) return

        if (this.state.sur_name === undefined) {
            this.setState({sur_name: ''})
        }
        const body = new FormData()

        let sAjaxSource = '/?app=partnersklients&act=createKlientIn1C'

        body.append('phone', this.state.unmaskedPhone);
        body.append('first_name', this.state.first_name ? this.state.first_name : 'Без имени');
        body.append('last_name', this.state.last_name ? this.state.last_name : 'Без фамилии');
        body.append('sur_name', this.state.sur_name ? this.state.sur_name : '');
        this.setState({loading: true})
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        ).then((response) => {
            this.setState({loading: false})
            if (Array.isArray(response.data)) {
                const result = response.data[0]
                if (result.errors !== undefined) {
                    if (result.errors.length == 0 && result.GUID !== undefined) {
                        const new_item = {
                            external_id: result.GUID,
                            INN: "",
                            phone: this.state.unmaskedPhone,
                            first_name: this.state.first_name,
                            last_name: this.state.last_name,
                            sur_name: this.state.sur_name
                        }
                        this.addKlientToList(new_item)
                    } else if (result.errors.length > 0) {
                        let text = '';
                        result.errors.map((el) => {
                            text += el + '\r\n'
                        })
                        window.postMessage({type: 'error', text: text, timeout: 5000})
                    }
                }
            } else {
                window.postMessage({type: 'error', text: response.data, timeout: 5000})
            }
        }).catch((error) => {
            if (error.response) {
                window.postMessage({type: 'error', text: error.response.data, timeout: 5000})
            }

            if (error.message()) {
                window.postMessage({type: 'error', text: error.data, timeout: 5000})
            }
        });
        // this.props.close()
    }

    addKlientToList = (item) => {
        window.postMessage({type: "addKlientToList", value: item})
        this.props.close()
    }

    searchByName = () => {
        window.postMessage({type: 'setSearchSelectObject', value: this.state.search_name})
        this.props.close()
    }
}

export default KlientCreatorByPhone